export const ZonasHorarias = Object.freeze({
    ZONA_SURESTE: "UTC-5",
    ZONA_CENTRO: "UTC-6",
    ZONA_PACIFICO: "UTC-7",
    ZONA_NOROESTE: "UTC-8"
});

export const getKeyZonaHoraria = (value) =>
    Object.keys(ZonasHorarias).find(key => ZonasHorarias[key] == value);
